import { Routes, Route, Navigate, useLocation, useSearchParams } from 'react-router-dom'
import { WalletModal } from './blinko/modals/wallet.modal'
import { TwitterCallback } from './routes/twitter.callback'
import { ConnectTwitterModal } from './blinko/modals/connect.twitter.modal'
import { ProfileSlot } from './blinko/components/ProfileSlot'
import { useAccount } from 'wagmi'
import { UnsupportedNetworkModal } from './core/modals/unsupported.network.modal'
import GamePage from './blinko/GamePage'
import { ReferralHandler } from './core/components/ReferralHandler'
import { blinkoReferralCodeStorage } from './core/storages'
import ReplayPage from './blinko/ReplayPage';
import VerifyPage from './blinko/VerifyPage';
import { PnLDashboard } from './blinko/PnLDashboard';
import { ProtectedDashboardRoute } from './blinko/components/ProtectedDashboardRoute';
import HistoryPage from './blinko/HistoryPage'
import KolPage from './blinko/KolPage'
import ClanPage from './blinko/ClanPage'
import ResetSelfExclusionPage from './blinko/ResetSelfExclusionPage';
import CsPage from './blinko/CsPage';
import { lazy, Suspense, useEffect } from 'react'
import { useSetAtom } from 'jotai'
import { atomAllowAllWallets } from './blinko/states'

const V4Game = lazy(() => import('./blinko/v4/V4Game'));
const V3Lab = lazy(() => import('./blinko/v3/V3Lab'));
const V3Page = lazy(() => import('./blinko/v3/V3Page'))

function App() {
  const { address } = useAccount()
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isIgamingDemoRoute = location.pathname === '/igaming-demo';
  const setAllowAllWallets = useSetAtom(atomAllowAllWallets)

  useEffect(() => {
    const flag = searchParams.get('allowAllWallets')
    if (!flag)
      return
    setAllowAllWallets(true)
  }, [searchParams]);

  return (
    <>
      <Routes>
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/" element={<GamePage />} />
        <Route path="/igaming-demo" element={<GamePage isIgamingDemo />} />
        <Route path="/v3" element={<Suspense fallback={null}><V3Page /></Suspense>} />
        <Route path="/v3-lab" element={<Suspense fallback={null}><V3Lab /></Suspense>} />
        <Route path="/v4" element={<Suspense fallback={null}><V4Game /></Suspense>} />
        <Route path="/replay/:gameId" element={<ReplayPage />} />
        <Route path="/history/:address" element={<HistoryPage />} />
        <Route path="/kol/:address" element={<KolPage />} />
        <Route path="/clan/:code" element={<ClanPage />} />
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/pnl" element={
          <ProtectedDashboardRoute>
            <PnLDashboard />
          </ProtectedDashboardRoute>
        } />
        <Route path="/twitter-callback" element={<TwitterCallback />} />
        <Route path="/reset-self-exclusion" element={<ResetSelfExclusionPage />} />
        <Route path="/cs" element={<CsPage />} />
      </Routes>

      <ReferralHandler storage={blinkoReferralCodeStorage} />

      {/* prefetch profile */}
      <ProfileSlot address={address}>
        {() => null}
      </ProfileSlot>

      {!isIgamingDemoRoute && (
        <>
          <ConnectTwitterModal />
          <WalletModal />
          <UnsupportedNetworkModal />
        </>
      )}
    </>
  )
}

export default App
